import { useState, useEffect } from 'react';
import { Save, MessageCircle } from 'lucide-react';

function AdminWhatsApp() {
  const [config, setConfig] = useState({
    activo: true,
    numero: '',
    mensaje: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/whatsapp-config`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setConfig(data);
      }
    } catch (error) {
      console.error('Error cargando config WhatsApp:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!config.numero.trim() || !config.mensaje.trim()) {
      setMessage({ type: 'error', text: 'El número y el mensaje son obligatorios' });
      return;
    }

    setSaving(true);
    setMessage(null);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/whatsapp-config`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          activo: config.activo,
          numero: config.numero,
          mensaje: config.mensaje
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage({ type: 'success', text: 'Configuración guardada correctamente' });
      } else {
        setMessage({ type: 'error', text: data.error || 'Error al guardar' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Error de conexión' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Toggle activo/inactivo */}
      <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200">
        <div className="flex items-center gap-3">
          <MessageCircle className="text-green-500" size={20} />
          <div>
            <p className="font-medium text-gray-800">Estado del botón</p>
            <p className="text-sm text-gray-500">
              {config.activo ? 'El botón está visible en el sitio' : 'El botón está oculto en el sitio'}
            </p>
          </div>
        </div>
        <button
          onClick={() => setConfig(prev => ({ ...prev, activo: !prev.activo }))}
          className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors duration-200 focus:outline-none ${
            config.activo ? 'bg-green-500' : 'bg-gray-300'
          }`}
        >
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-200 ${
              config.activo ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>

      {/* Número de WhatsApp */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Número de WhatsApp
        </label>
        <input
          type="text"
          value={config.numero}
          onChange={e => setConfig(prev => ({ ...prev, numero: e.target.value.replace(/\D/g, '') }))}
          placeholder="Ej: 5491168455604 (sin + ni espacios)"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
        />
        <p className="text-xs text-gray-400 mt-1">
          Incluir código de país sin el +. Ejemplo: 5491168455604
        </p>
      </div>

      {/* Mensaje predeterminado */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Mensaje predeterminado
        </label>
        <textarea
          value={config.mensaje}
          onChange={e => setConfig(prev => ({ ...prev, mensaje: e.target.value }))}
          rows={4}
          placeholder="Mensaje que se pre-carga cuando el usuario abre WhatsApp..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm resize-none"
        />
        <p className="text-xs text-gray-400 mt-1">
          Este texto aparecerá pre-escrito en el chat de WhatsApp cuando el usuario haga clic en el botón.
        </p>
      </div>

      {/* Mensaje de feedback */}
      {message && (
        <div className={`p-3 rounded-lg text-sm ${
          message.type === 'success'
            ? 'bg-green-50 text-green-700 border border-green-200'
            : 'bg-red-50 text-red-700 border border-red-200'
        }`}>
          {message.text}
        </div>
      )}

      {/* Botón guardar */}
      <div className="flex justify-end">
        <button
          onClick={handleSave}
          disabled={saving}
          className="flex items-center gap-2 px-5 py-2.5 bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white font-medium rounded-lg transition-colors duration-200 text-sm"
        >
          <Save size={16} />
          {saving ? 'Guardando...' : 'Guardar cambios'}
        </button>
      </div>
    </div>
  );
}

export default AdminWhatsApp;
